import * as React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function BasicDatePicker({
  label,
  name,
  value,
  onChange,
  customStyles,
  disable=false,
  minDate,
  maxDate,
  module,
  required
}: {
  label?:React.ReactNode| string;
  name?: string;
  value?: any;
  onChange?: any;
  customStyles?: React.CSSProperties;
  datePickerStyles?: React.CSSProperties;
  disable?:boolean;
  minDate?:any;
  maxDate?:any;
  textColor?:string;
  required?:boolean;
  module?:string;
}) {
  const isRow = customStyles?.flexDirection === "row";
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        ...customStyles,
      }}
    >
      <label
        className={isRow ? "text-textGray" : ""}
        style={{
          fontSize: "0.8rem",
          color: isRow ? undefined : "#1e293b",
          marginBottom: isRow ? 0 : "4px",
          minWidth: isRow ? "8.5rem" : undefined,
          width: isRow ? "8.5rem" : undefined,
          flexShrink: 0,
        }}
      >
        {label}
        {module === "invoice" && required && <span className="text-red-500">*</span>}
      </label>
      <div style={{ flex: isRow ? 1 : undefined, minWidth: isRow ? 0 : undefined, width: isRow ? "auto" : "100%" }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          format="dd/MM/yyyy"
          value={value}
          onChange={(date: any) => {
            if (onChange) onChange(date); // ✅ Only call if provided
          }}
          disabled={disable}
          minDate={minDate}
          maxDate={maxDate}
          
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true,
              error: false,
              name,
              sx: isRow
                ? {
                    "& .MuiOutlinedInput-root": {
                      height: "2.3rem",
                    },
                    "& input": {
                      fontSize: "0.8rem",
                    },
                  }
                : undefined,
              inputProps: {
                readOnly: true,
               // ✅ This disables typing
              },
              //prevents from changing the value through tabs
              InputProps: {
                inputProps: {
                  inputMode: "none",
                  readOnly: true,
                },
                readOnly: true,
                onKeyDown: (e: React.KeyboardEvent) => {
                  const blockedKeys = [
                    "ArrowUp",
                    "ArrowDown",
                    "ArrowLeft",
                    "ArrowRight",
                    "Backspace",
                    "Delete",
                    " ",
                     "0","1","2","3","4","5","6","7","8","9"
                  ];
                  if (blockedKeys.includes(e.key)) {
                    e.preventDefault();
                  }
                },
              },
            } as any,
          }}
        />
      </LocalizationProvider>
      </div>
    </div>
  );
}
